import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { cleanEvent, eventInitialData } from '../../UI-components/Modals/CashierModal/CashierModal'
import { BRAND_KEY, DEFAULT_CURRENCY } from '../../core/const'
import { EventName } from '../../core/enums/moneyOperations'
import Utils from '../../core/Utils'
import { useAppSelector } from '../../redux/hooks'
import { RootState } from '../../redux/store'
import './WidgetGame.scss'

type BalanceListener = (balance: number) => void

interface WidgetGameProps {
	gameId: string
	gameName: string
	widgetUrl: string
	onSubmit: (eventName?: EventName, eventData?: any, close?: boolean) => void
}

const WidgetGame: React.FC<WidgetGameProps> = ({ gameId, gameName, widgetUrl, onSubmit }) => {
	const navigate = useNavigate()
	const balance = useAppSelector((state: RootState) => state.wallet.balance)
	const balanceRef = useRef(balance)
	const onSubmitRef = useRef(onSubmit)
	const navigateRef = useRef(navigate)
	const listenersRef = useRef(new Set<BalanceListener>())

	onSubmitRef.current = onSubmit
	navigateRef.current = navigate

	useEffect(() => {
		balanceRef.current = balance
		listenersRef.current.forEach((listener) => listener(balance))
	}, [balance])

	useEffect(() => {
		const listeners = listenersRef.current
		;(window as any).fakeCasino = {
			version: 1,
			getContext: () => ({
				gameId,
				gameName,
				currency: DEFAULT_CURRENCY,
				balance: balanceRef.current,
				isMobile: Utils.isMobile(),
			}),
			spin: ({ bet, win }: { bet: number; win: number }) => {
				if (!Number.isFinite(bet) || !Number.isFinite(win) || bet <= 0 || win < 0) {
					return { ok: false, error: 'invalid_amounts' }
				}
				const data = cleanEvent(EventName.casino_bet_win, {
					...eventInitialData,
					bet,
					win: Math.floor(win),
					game_name: gameId,
					brand_key: BRAND_KEY,
				} as any)
				onSubmitRef.current(EventName.casino_bet_win, data)
				return { ok: true }
			},
			onBalanceChange: (listener: BalanceListener) => {
				listeners.add(listener)
				return () => {
					listeners.delete(listener)
				}
			},
			goToLobby: () => navigateRef.current('/'),
			openGame: (nextGameId: string) => navigateRef.current(`/game/${encodeURIComponent(nextGameId)}`),
		}
		return () => {
			listeners.clear()
			delete (window as any).fakeCasino
		}
	}, [gameId, gameName])

	return (
		<div className="main-content game-page widget-game-page">
			<GamificationBlock key={gameId} url={widgetUrl} domId="smr-widget-casino-game" fit="fill" className="gamification-block--game" cacheBust={false} />
		</div>
	)
}

export default WidgetGame
